import * as Turbo from '@hotwired/turbo'
import Dialog, { type DialogOptions } from '/libs/dialog'
import { i18n } from '/locales/i18n'

type ConfirmOptions = DialogOptions & {
  cancelLabel?: string
  continueLabel?: string
  putForwardCancellation?: boolean
}

export default class Confirm extends Dialog {
  private cancelLabel: string
  private continueLabel: string
  private putForwardCancellation: boolean

  /** Creates a confirmation dialog ready to be rendered with `show()`. */
  constructor(message: string | DocumentFragment, options: ConfirmOptions = {}) {
    super(message, options)

    this.cancelLabel = options.cancelLabel || i18n.t('js.common.cancel')
    this.continueLabel = options.continueLabel || i18n.t('js.common.continue')
    this.putForwardCancellation = options.putForwardCancellation || false
  }

  /** Registers this dialog as Turbo's Rails-compatible confirmation handler. */
  static railsSetup() {
    Turbo.config.forms.confirm = (message: string, element: HTMLElement) => {
      const options = element.dataset.confirm
        ? (JSON.parse(element.dataset.confirm) as ConfirmOptions)
        : {}
      const confirm = new Confirm(message, options)
      return confirm.show()
    }
  }

  protected templateContent() {
    let continueClass = 'is-main'
    let cancelClass = 'is-secondary'
    let footerClass = ''

    if (this.putForwardCancellation) {
      const defaultContinueClass = continueClass
      continueClass = cancelClass
      cancelClass = defaultContinueClass
      footerClass = 'flex-row-reverse'
    }

    return `
      ${this.templateTitle()}
      <div data-dialog-message></div>
      <div class="modal-footer ${footerClass}">
        <button data-dialog-resolve="false" class="button ${cancelClass}">${this.cancelLabel}</button>
        <button data-dialog-resolve="true" class="button ${continueClass}">${this.continueLabel}</button>
      </div>`
  }
}
